import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataList from "../../components/DataList.jsx";
import ModalContainer from "../../components/ModalContainer.jsx";
import { getSingleOrderService } from "../../services/ordersServices.js";
import Alert from "../../utils/Alert.js";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { AllProvincesArray } from "../../utils/convertProvince.js";
import Delivery from "./additionFields/Delivery.jsx";
import Status from "./additionFields/Status.jsx";


const OrderDetails = () => {
  const [orderData, setOrderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  const findProvinceNameByState = (state) => {
    const province = AllProvincesArray.find((prov) => prov.state === state);
    return province ? province.name : "";
  };

  const orderRows = [
      {
        field: "code",
        text: "کد سفارش"
      },
      {
          field: null,
          text: "وضعیت",
          element: (rowData) => <Status rowData={rowData} />
      },
      {
          field: "tracking_code",
          text: "کد رهگیری"
      },
      {
          field: null,
          text: "تاریخ ثبت سفارش",
          element: (rowData) => <span>{rowData.order_date ? convertDateToJalaali(rowData.order_date) : ""}</span>
      },
      {
          field: null,
          text: "تاریخ پرداخت",
          element: (rowData) => <span>{rowData.transaction_date ? convertDateToJalaali(rowData.transaction_date) : ""}</span>
      },
      {
          field: null,
          text: "هزینه سفارش",
          element: (rowData) => <span>{rowData.total_price ? rowData.total_price.toLocaleString() : ""}</span>
      },
      {
          field: null,
          text: "هزینه ارسال",
          element: (rowData) => <span>{rowData.transfer_price ? rowData.transfer_price.toLocaleString() : ""}</span>
      },
      {
          field: null,
          text: "میزان تخفیف",
          element: (rowData) => <span className={`${!rowData.discount_amount ? "text-red-500" : ""}`}>{rowData.discount_amount ? `${rowData.discount_amount.toLocaleString()} تومان` : "ندارد"}</span>
      },
      {
          field: null,
          text: "مبلغ پرداختی",
          element: (rowData) => <span>{rowData.payment_price ? rowData.payment_price.toLocaleString() : ""}</span>
      },
      {
          field: null,
          text: "نوع تحویل",
          element: (rowData) => <Delivery rowData={rowData} />
      },
      {
        field: null,
        text: "استان",
        element: (rowData) => (
          <span>
            {rowData.order_address ? findProvinceNameByState(rowData.order_address.province) : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شهر",
        element: (rowData) => (
          <span>{rowData.order_address ? rowData.order_address.city : ""}</span>
        ),
      },
      {
        field: null,
        text: "آدرس",
        element: (rowData) => (
          <span>
            {rowData.order_address ? rowData.order_address.physical_address : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "نام شرکت",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.name : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شناسه ملی",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.national_id : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شماره ثبت",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.registration_number : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "کد اقتصادی",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.economic_code : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "استان (محل دفتر مرکزی)",
        element: (rowData) => (
          <span>
            {rowData.order_company ? findProvinceNameByState(rowData.order_company.province) : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شهر (محل دفتر مرکزی)",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.city : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "آدرس ثبت",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.registration_address : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شماره تلفن ثبت",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.registration_phone_number : ""}
          </span>
        ),
      },
      {
        field: null,
        text: "شماره شبا (بدون IR)",
        element: (rowData) => (
          <span>
            {rowData.order_company ? rowData.order_company.SHABA_number : ""}
          </span>
        ),
      },
    ];

  const handleGetOrderData = async (orderCode) => {
    setIsLoading(true);
    try {
      const response = await getSingleOrderService(orderCode);
      if (response.status === 200) {
        setOrderData(response.data);
      }
    } catch (error) {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "در دریافت جزئیات سفارش مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.",
        "error"
      );
      return navigate(-1);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (location.state) {
      handleGetOrderData(location.state.code);
    } else {
      return navigate(-1);
    }
  }, []);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`سفارش "${location.state?.code}"`}
    >
      <DataList
        listData={orderData}
        listRowsTitles={orderRows}
        isLoading={isLoading}
      />
    </ModalContainer>
  );
};

export default OrderDetails;
